import React from 'react';

interface IInvoiceBadge {
  border: string;
  background: string;
  icon: any;
  text: string;
}

const InvoiceBadge: React.FC<IInvoiceBadge> = ({ border, background, icon, text }) => {
  return (
    <div className='invoice-status-badge'>
      <div
        style={{ border: border, background: background }}
        className='invoice-badge-base'
      >
        {icon}
        <div className='invoice-badge-text'>
          {text}
        </div>
      </div>
    </div>
  );
};

export default InvoiceBadge;
